import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Timecode from '../../util/timecode';
import { Input as DefaultInput } from '../../styled-components';
import localize from '../../util/localizeUtils';

const Label = styled.div`
  display: inline-block;
  font-size: 10px;
  text-align: right;
  min-width: 2rem;
  margin-right: 0.2rem;
`;

const Input = styled(DefaultInput)`
  height: 1.25rem;
  width: 1.5rem;

  &.error {
    border: 1px solid red;
  }
`;

const TimecodeRow = styled.div`
  height: 1.25rem;
`;

class TimecodeDisplay extends React.Component {
  constructor() {
    super();
    this.state = {
      hour: '00',
      minute: '00',
      second: '00',
      frames: '00'
    };
  }

  componentDidMount = () => {
    const { timecode } = this.props;
    const time = Timecode.parseTimecode(timecode, this.props.frameRate);
    this.setState({
      hour: Timecode.formatNumber(time.hour),
      minute: Timecode.formatNumber(time.minute),
      second: Timecode.formatNumber(time.second),
      frames: Timecode.formatNumber(time.frames)
    });
  };

  UNSAFE_componentWillReceiveProps = nextProps => {
    if (this.props.timecode !== nextProps.timecode) {
      const { timecode } = nextProps;
      const time = Timecode.parseTimecode(timecode, this.props.frameRate);
      this.setState({
        hour: Timecode.formatNumber(time.hour),
        minute: Timecode.formatNumber(time.minute),
        second: Timecode.formatNumber(time.second),
        frames: Timecode.formatNumber(time.frames)
      });
    }
  };

  updateHour = event => {
    this.setState({ hour: event.target.value });
  };

  updateMinute = event => {
    this.setState({ minute: event.target.value });
  };

  updateSecond = event => {
    this.setState({ second: event.target.value });
  };

  updateFrames = event => {
    this.setState({ frames: event.target.value });
  };

  constructNewTimecode = () => {
    if (this.props.timecodeChanged === undefined) {
      return;
    }

    let { hour, minute, second, frames } = this.state;

    hour = hour || '00';
    minute = minute || '00';
    second = second || '00';
    frames = frames || '00';

    if (((!this.state.hour !== !this.state.minute) !== !this.state.second) !== !this.state.frames) {
      this.setState({
        hour,
        minute,
        second,
        frames
      });
    }

    let timeCode = new Timecode(
      Timecode.formatNumber(hour),
      Timecode.formatNumber(minute),
      Timecode.formatNumber(second),
      Timecode.formatNumber(frames),
      this.props.frameRate
    );

    if (
      this.props.maxSeconds &&
      Timecode.convertToSeconds(timeCode, timeCode.framerate) > this.props.maxSeconds
    ) {
      timeCode = new Timecode(
        Timecode.formatNumber(0),
        Timecode.formatNumber(0),
        Timecode.formatNumber(this.props.maxSeconds),
        Timecode.formatNumber(0),
        this.props.frameRate
      );

      this.setState({
        hour: timeCode.hour,
        minute: timeCode.minute,
        second: timeCode.second,
        frames: timeCode.frames
      });
    }
    this.props.timecodeChanged(timeCode.getTimecodeString());
  };

  TimecodeInput = ({ value, onChange, className }) => (
    <Input
      className={className}
      onClick={e => e.target.select()}
      disabled={this.props.disabled}
      maxLength="2"
      type="text"
      value={value}
      onChange={onChange}
      onBlur={this.constructNewTimecode}
    />
  );

  isDirty = () => {
    const { hour, minute, second, frames } = this.state;
    return hour !== '00' || minute !== '00' || second !== '00' || frames !== '00';
  };

  render() {
    const { label, maxSeconds } = this.props;
    const { hour, minute, second, frames } = this.state;
    const shouldDisplayPlaceholders = false; //! this.isDirty();
    return (
      <TimecodeRow>
        <Label>{`${label}${maxSeconds > 0 ? localize('timecodeMaxFormat').replace('{max}', maxSeconds) : ''}`}</Label>
        <this.TimecodeInput
          ref={this.props.hourInputRef}
          value={shouldDisplayPlaceholders ? localize('timecodeHrPlaceholder') : hour}
          onChange={this.updateHour}
          className={!shouldDisplayPlaceholders && isNaN(hour) ? 'error' : ''}
        />
        <span>:</span>
        <this.TimecodeInput
          value={shouldDisplayPlaceholders ? localize('timecodeMinPlaceholder') : minute}
          onChange={this.updateMinute}
          className={!shouldDisplayPlaceholders && isNaN(minute) ? 'error' : ''}
        />
        <span>:</span>
        <this.TimecodeInput
          value={shouldDisplayPlaceholders ? localize('timecodeSecPlaceholder') : second}
          onChange={this.updateSecond}
          className={!shouldDisplayPlaceholders && isNaN(second) ? 'error' : ''}
        />
        <span>:</span>
        <this.TimecodeInput
          value={shouldDisplayPlaceholders ? localize('timecodeFramePlaceholder') : frames}
          onChange={this.updateFrames}
          className={!shouldDisplayPlaceholders && isNaN(frames) ? 'error' : ''}
        />
      </TimecodeRow>
    );
  }
}

TimecodeDisplay.defaultProps = {
  disabled: false,
  timecodeChanged: () => {},
  hourInputRef: () => {},
  frameRate: null,
  maxSeconds: null
};

TimecodeDisplay.propTypes = {
  disabled: PropTypes.bool,
  label: PropTypes.string.isRequired,
  timecode: PropTypes.string.isRequired,
  timecodeChanged: PropTypes.func,
  frameRate: PropTypes.number,
  hourInputRef: PropTypes.func,
  maxSeconds: PropTypes.number
};

export default TimecodeDisplay;



// WEBPACK FOOTER //
// ./app/components/Editor/TimecodeDisplay.js